import React from "react";

import { clientUrl, staticUrl } from "../../constants/site-urls";
import { createEvent } from "../../utils/create-event";

const TemplateSummary = ({ template }) => {
  return (
    <li className="col-span-1">
      <a
        className="p-4 group flex flex-col align-middle border-2 border-transparent rounded-xl overflow-hidden bg-slate-50 hover:cursor-pointer hover:border-emerald-100"
        href={`${clientUrl}/template/${template.slug}`}
        onClick={() => {
          createEvent("View templates");
        }}
      >
        <img className="rounded" src={`${staticUrl}/${template.image_link}`} />
        <div className="flex flex-grow flex-col">
          <div className="flex flex-row">
            <p className="text-sm text-gray-700 pt-4 font-semibold">
              {template.name}
            </p>
          </div>
          <span className="text-xs text-gray-500">
            {template.type}{" "}
            {template.type === "Example" ? "extension" : "template"}
          </span>
        </div>
      </a>
    </li>
  );
};

export default TemplateSummary;
